module.exports = __webpack_public_path__ + "media/images/tutorial_body_sp3-03-0a5fc2ee9dbefcf426309da8a4db5899.png";